import React, { useEffect, useState } from "react";
import SideBarBack from "../../components/SidebarBack";
import { useDispatch } from "react-redux";
import secureLocalStorage from "react-secure-storage";
import { setDrawerActiveMenu } from "../../store/features/webUtilitiesSlice";
import {
  POST_PROFILE_SURVEY,
  PROFILEENDPOINT,
} from "../../config/ApisCollection";
import axios from "axios";
import AllergyImage from "../../assets/imagehandler/AllergyImage";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function AllergyPrefrences() {
  const dispatch = useDispatch();
  const accessToken = secureLocalStorage.getItem("accessToken");
  const [data, setData] = useState([]);
  const [selectedItemNum, setSelectedItemNum] = useState(0);

  const handleCloseDrawer = async () => {
    await dispatch(setDrawerActiveMenu(31));
  };

  const GetAllegeryData = async () => {
    const get_header = {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
      },
    };

    await axios.get(PROFILEENDPOINT, get_header).then((response) => {
      setData(response.data.data);
    });
  };

  const handleChange = (index, itemId, isTrue) => {
    // Create a new copy of the surveyItems array

    const updatedSurveyItems = [...data.surveyItems];

    // Update the specific item within the categoryItems array
    updatedSurveyItems[2].categoryItems = updatedSurveyItems[2].categoryItems.map(
      (item, i) => {
        if (i === 0 && index === 0) {
          return { ...item, isTrue: isTrue }; // Set isTrue to true for index 0
        } else if (index !== 0 && i == index) {
          return { ...item, isTrue: isTrue }; // Set isTrue to true for index 0
        } else if (i == 0 && index !== 0) {
          return { ...item, isTrue: 0 }; // Set isTrue to true for index 0
        } else if (index === 0) {
          return { ...item, isTrue: 0 }; // Set isTrue to false for all others if index is 0
        }
        return item;
      }
    );

    // Create a new data object with the updated surveyItems
    const updatedData = {
      ...data,
      surveyItems: updatedSurveyItems,
    };

    // Update the state with the new data object
    setData(updatedData);

    // Dissable button if not any selected
    let counttrueval = 0;
    updatedSurveyItems[2].categoryItems.map((item, i) => {
      if (item?.isTrue == 1) {
        counttrueval++;
      }
    });
    setSelectedItemNum(counttrueval);
  };

  const postSurveyData = (surveyItemsData) => {
    //---------------deletion of uneccesary items--------------------------
    const ingredient_allergies = Object.fromEntries(
      Object.entries(surveyItemsData[2].categoryItems).map(([key, value]) => {
        const { name, dark_icon, light_icon, imgname, subcat, ...rest } = value;
        return [key, rest];
      })
    );

    const postItems = {
      surveyItems: [
        {
          category: "ingredient_allergies",
          categoryItems: Object.values(ingredient_allergies),
        },
      ],
    };

    //---------------Deletion of unnecessary items---------------------------

    const live_url = POST_PROFILE_SURVEY;
    const postSurveyBody = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
      body: JSON.stringify(postItems),
    };

    fetch(live_url, postSurveyBody)
      .then((postSurRes) => postSurRes.json())
      .then((postSurResult) => {
        if (postSurResult["error"]) {
          if (postSurResult["error"].message === "token expired") {
            window.location.href = "/login";
          } else {
            toast.error(postSurResult.error.message);
          }
        } else {
          toast.success(postSurResult.message);
        }
      })
      .catch((postSurErr) => {});
  };

  useEffect(() => {
    GetAllegeryData();
  }, []);

  return (
    <div className="w-full h-full">
      <div className="w-full flex mb-2">
        <SideBarBack
          className="bg-transparent"
          handleCloseDrawer={handleCloseDrawer}
        />
      </div>

      {data?.surveyItems && data?.surveyItems[2]?.categoryItems ? (
        <>
          <div className="text-center w-11/12 mt-2 mx-auto pb-8 gap-6 flex flex-col justify-between">
            <p className="text-2xl font-medium">
              Do you have any{" "}
              <span className="text-[#FF9950]"> ingredients allergy </span> ?
            </p>
            <p className="text-sm">Choose all that apply</p>
          </div>

          <div className="max-w-[400px] m-auto grid grid-cols-2 mt-5 pt-5 justify-items-center mt-2 sm:mb-5 mb-5 sm:gap-5 gap-1 mob-grid-2">
            {data?.surveyItems &&
              data?.surveyItems[2]?.categoryItems?.map((diet_row, index) => {
                return (
                  <div
                    className={
                      diet_row.isTrue == 1
                        ? "gap-2 m-0 px-1.5 cardlyac  mb-2 font-bold"
                        : "gap-2 m-0 px-1.5 cardly  mb-2"
                    }
                    key={index}
                    onClick={() => {
                      handleChange(
                        index,
                        diet_row.itemId,
                        diet_row.isTrue == 0 || diet_row.isTrue == null ? 1 : 0
                      );
                    }}
                  >
                    <div className="w-[88px] flex-col">
                      {/* {console.log(diet_row)} */}
                      <img
                        loading="lazy"
                        src={AllergyImage["allergy" + index]}
                        className="icongol m-auto"
                        alt="Very Often"
                      />
                      <div className="text-center mt-4 text-xs">
                        <p>{diet_row.name}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
          <ToastContainer position="bottom-right" />
          {selectedItemNum != 0 ? (
            <button
              className="bg-[#FF9950] absolutes  bottom-10 text-white text-sm mx-auto w-full py-4 mt-6 rounded-2xl mb-10"
              onClick={() => {
                postSurveyData(data.surveyItems);
              }}
            >
              Update preferences
            </button>
          ) : (
            <button className="bg-[#ddd] absolutes bottom-10 text-white text-sm mx-auto w-full py-4 mt-6 rounded-2xl mb-10">
              Update preferences
            </button>
          )}
        </>
      ) : (
        <div className="flex flex-col justify-center h-[80vh]">
          <p class="text-center">Loading...</p>
        </div>
      )}
    </div>
  );
}
